import { createSlice } from '@reduxjs/toolkit'

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    data: [],
    loading: false,
    error: null
  },
  reducers: {
    fetchDataCount: (state) => {
      state.loading = true
      state.error = null
    },
    fetchDataCountSuccess: (state, action) => {
      state.loading = false
      state.data = action.payload
    },
    setDataCount: (state, action) => {
      state.data = action.payload
    }
  }
})

export const { fetchDataCount, fetchDataCountSuccess, setDataCount } = notificationSlice.actions

const notificationReducer = notificationSlice.reducer
export default notificationReducer
